// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"style_tableContainer__2fbuO","table":"style_table__2sWse"};